<template>
    <div>
        <el-form
            ref="loginForm"
            :model="loginform"
            :rules="rules"
            label-width="80px"
        >
            <h3 class="login-title">欢迎登录</h3>
            <el-form-item label="姓名" prop="employeeName">
                <el-select
                    v-model="queryParamsDown.employeeName"
                    style="width:100%"
                    clearable
                    size="small"
                    placeholder="输入姓名查询"
                    filterable
                    remote
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="handleRemoteMethodChange($event)"
                    >
                    <el-option
                        v-for="item in pageDataDown"
                        :key="item.employeeId"
                        :label="item.employeeName"
                        :value="item"
                        >
                        <span>{{ item.employeeName }}</span>
                        <span style="color: #8492a6"> {{ item.idCard }}</span>
                        <span style="color: #8492a6"> {{ item.phone }}</span>
                        <span style="color: #8492a6"> {{ item.dept }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="账号" >
                <el-input
                    type="text"
                    placeholder="请输入账号"
                    v-model="loginform.userName"
                />
            </el-form-item>
            <el-form-item label="密码" >
                <el-input
                    type="userPwd"
                    placeholder="请输入密码"
                    v-model="loginform.userPwd"
                />
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="isChecked"> 30天内记住我</el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    :loading="logining"
                    v-on:click="login()"
                    >登录</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import Axios from "axios";
import {  loginInfo } from "@/api/login"

export default {
    components: {},
    name: "Login",
    data() {
        return {
            activeName: "first",
            logining: false,
            loginform: {
                userName: "",
                userPwd: "",
            },
            isChecked: true,

            // 表单验证，需要在 el-form-item 元素中增加 prop 属性
            rules: {
                user: [
                    {
                        required: true,
                        message: "账号不可为空",
                        trigger: "blur",
                    },
                ],
                userPwd: [
                    {
                        required: true,
                        message: "密码不可为空",
                        trigger: "blur",
                    },
                ],
            },
            usernameText: "",
            passwordText: "",
            // 对话框显示和隐藏
            // dialogVisible: false
            loading: false,
            // 带搜索的下拉框
            pageDataDown: {},
            queryParamsDown: {
                pageNum: 1,
                pageSize: 10,
                employeeName: undefined
            }
        }
    },
    mounted() {
        this.getCookie();
    },
    created() {
        this.remoteMethod('')
    },

    methods: {
        onSubmit() {
            // console.log(this.form)
            // 为表单绑定验证功能
            // this.$refs.loginForm.validate((valid) => {
            //     if (valid) {
            //         this.logining = true;
            //         let _this = this;
            //         if (_this.logining == true) {
            //             Axios.get("http://localhost:8181/admin/login", {
            //                 params: this.loginform,
            //             }).then(function (res) {
            //                 _this.logining = false;
            //                 // console.log(res.data.code)
            //                 if (res.data.code == -1) {
            //                     _this.$message.error("用户名不存在");
            //                 }
            //                 if (res.data.code == -2) {
            //                     _this.$message.error("密码错误");
            //                 }
            //                 if (res.data.code == 0) {
            //                     _this.$message({
            //                         message: "恭喜你，登录成功",
            //                         type: "success",
            //                     });
            //                     localStorage.setItem(
            //                         "main",
            //                         JSON.stringify(res.data.data)
            //                     );
            //                     _this.$router.replace({ path: "/main" });
            //                 }
            //             });
            //         }
            //     }
            //     // 使用 vue-router 路由到指定页面，该方式称之为编程式导航
            //     // this.$router.push("/main");
            //     // } else {

            //     //   // return false;
            //     // }
            // });
        },
        // 登录按钮
        login() {
            // 判断复选框是否被勾选; 勾选则调用配置Cookie方法
            if (this.isChecked) { // 记住密码
                this.setCookie(this.loginform.userName, this.loginform.userPwd, 30); // 保存期限为30天
            } else {
                this.clearCookie(); // 清空 Cookie
            }
        },
 
        // 设置Cookie
        setCookie(username, userPwd, exdays) { // 用户名, 密码, 保存天数
            let exdate = new Date(); // 获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
            // 字符串拼接cookie
            window.document.cookie = 'userName=' + username + ';path=/;expires=' + exdate.toGMTString();
            window.document.cookie = 'userPwd=' + userPwd + ';path=/;expires=' + exdate.toGMTString();
        },
 
        // 读取Cookie
        getCookie() {
            // console.log(document.cookie);
            if (document.cookie.length > 0) {
                let arr = document.cookie.split('; '); // 这里显示的格式需要切割一下自己可输出看下
                for (let i = 0; i < arr.length; i++) {
                    let arr2 = arr[i].split('='); // 再次切割
                    // 判断查找相对应的值
                    if (arr2[0] == 'loginform.userName') {
                        this.usernameText = arr2[1]; // 保存到保存数据的地方
                    } else if (arr2[0] == 'loginform.userPwd') {
                        this.passwordText = arr2[1];
                    }
                }
            }
        },
 
        // 清除Cookie
        clearCookie() {
            this.setCookie('', '', -1); // 修改2值都为空，天数为负1天就好了
        },

        // 带搜索的下拉框
        remoteMethod(query) {
            this.queryParamsDown.employeeName = query
            this.loading = true
            // personApi.listForPage(this.queryParamsDown).then(res => {
            //   this.loading = false
            //   this.pageDataDown = res.data
            // })
        },
        // 带搜索的下拉框-选值后处理
        handleRemoteMethodChange(item) {
          this.form.employeeIdcard = item.idCard
          this.form.employeePhone = item.phone
          this.form.employeeDept = item.dept
          // 回填下拉框值为正确的值(el-select下拉框获取选中的整个对象值)
          this.employeeName = item.employeeName
        }



















        // 设置Cookie
        // setCookie(username, userPwd, exdays) { // 用户名, 密码, 保存天数
        //     let exdate = new Date(); // 获取时间
        //     exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
        //     // 字符串拼接cookie
        //     window.document.cookie = 'userName=' + username + ';path=/;expires=' + exdate.toGMTString();
        //     window.document.cookie = 'userPwd=' + userPwd + ';path=/;expires=' + exdate.toGMTString();
        // },
 
        // 读取Cookie
        // getCookie() {
        //     // console.log(document.cookie);
        //     if (document.cookie.length > 0) {
        //         let arr = document.cookie.split('; '); // 这里显示的格式需要切割一下自己可输出看下
        //         for (let i = 0; i < arr.length; i++) {
        //             let arr2 = arr[i].split('='); // 再次切割
        //             // 判断查找相对应的值
        //             if (arr2[0] == 'loginform.userName') {
        //                 this.usernameText = arr2[1]; // 保存到保存数据的地方
        //             } else if (arr2[0] == 'loginform.userPwd') {
        //                 this.passwordText = arr2[1];
        //             }
        //         }
        //     }
        // },
 
        // 清除Cookie
        // clearCookie() {
        //     this.setCookie('', '', -1); // 修改2值都为空，天数为负1天就好了
        // },
    },
}
</script>
 
<style scoped>
.login-box {
    border: 1px solid #dcdfe6;
    width: 350px;
    margin: 180px auto;
    padding: 35px 35px 15px 35px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    box-shadow: 0 0 25px #909399;
}

.login-title {
    text-align: center;
    margin: 0 auto 40px auto;
    color: #303133;
}
</style>


// WEBPACK FOOTER //
// src/views/Login/Register.vue